import axios from "axios";

// Use a relative /api base so the frontend always calls whatever host it's
// served from (preview, production, or a connected custom domain like
// bcpeabody.com). Emergent's ingress routes /api/* to the backend on both.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
});
